import { useQuery } from 'react-query';
import { client } from 'utilities/db';

export const useFetchDashboardHook = (keyName, branchId, fromDate, toDate) => {
  const { status, data, error, isFetching, isLoading, refetch } = useQuery(
    [keyName, branchId, fromDate, toDate],
    () => getData(branchId, fromDate, toDate),
    {
      enabled: !!branchId,
      refetchInterval: 60000
    }
  );

  return {
    dashboardStatus: status,
    dashboardData: data,
    dashboardError: error,
    dashboardFetching: isFetching,
    dashboardLoading: isLoading,
    dashboardRefetch: refetch
  };
};

const getData = async (branchId, fromDate, toDate) => {
  let result = await client.post(`/reporting/overview/getByBranchId`, {
    branch_id: branchId,
    from_date: fromDate,
    to_date: toDate
  });
  result = result.data;
  return result;
};
